import { useQuery } from 'react-query'
import luminaireAPI from '../service/luminaireAPI'
import { LuminaireEffectiveConfig } from '../types/luminaire.types'

export const useLuminaireEffectiveConfig = (devEui: string) => {
  return useQuery<LuminaireEffectiveConfig>({
    queryKey: ['luminaire-effective-config', devEui],
    queryFn: () => luminaireAPI.getEffectiveConfig(devEui),
    enabled: Boolean(devEui),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}

